import React from 'react';
import { ShowcaseBoxContent } from '../../../types/content';
import CartICon from '../../UI/SVG/CartIcon';
import StaticImage from '../../UI/Image/StaticImage';
import WalletIcon from '../../UI/SVG/WalletIcon';
import Fixedprice from '../FixedPrice';
import { getAmount } from '../../../utils';

interface IBoxThreeProps {
  content: ShowcaseBoxContent;
}

const BoxThree = ({ content }: IBoxThreeProps) => {
  return (
    <div className='guide-box guide-box__three'>
      <div className='left'>
        <div className='cart-icon'>
          <CartICon fill='#35C1CF' />
          <div className='cart-item-count'>{content.games.length}</div>
        </div>
        <div className='game-list'>
          {content.games.map((game, index) => (
            <StaticImage key={`game_${index}`} imageName={game} altText={game} extension='jpg' />
          ))}
        </div>
      </div>
      <div className='right'>
        <div className='summary-boxes'>
          <div className='summary-boxes__wallet'>
            <div className='summary-boxes__wallet__left'>
              <WalletIcon fill='white' />
              {content.box1.left}
            </div>
            <div className='summary-boxes__wallet__right'>
              {content.box1.right_title}
              <span className='balance-amount'>
                <Fixedprice price={getAmount(content.box1.right_amount)} width={20} fill='white' />
              </span>
            </div>
          </div>
          <div className='summary-boxes__payments'>
            <div className='summary-boxes__payments__left'>
              <div className='summary-boxes__payments__left__icon' role='image' />
            </div>
            <div className='summary-boxes__payments__right'>{content.box2.right_title}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxThree;
